import { useQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { storyClient } from '../client/storyClient';


type Options = {
  enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useStoriesQuery = (params: Stories.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getStories, params],
    queryFn: () => storyClient.getStories(params),
    enabled: options.enabled !== undefined ? options.enabled : defaultOptions.enabled,
  });

  return {
    ...rest,
    count: data?.count || 0,
    stories: data?.results || [],
  };
};
